import React from 'react'
import { AlertModalProps } from '@musinsa/mwms-ds'
import { AlertModalList } from '@/components/content/Alert'
import { Utils } from '@/utils/Utils'
import ModalAction from '@/utils/modal/ModalAction'

const ALERT_ID = 'moms-alert'

type MAlertActionType = Omit<AlertModalProps, 'open'>

class MAlertAction extends ModalAction<MAlertActionType> {
  destroy = (id: string) => {
    const deletedIdx = this.list.findIndex((alert) => alert.id === id)
    this.list.splice(deletedIdx, 1)

    if (this.root && this.list.length) {
      this.root.render(<AlertModalList list={this.list} destroy={this.destroy} />)
    }
  }

  /**
   * dedupe 는 문자열 content 만 대상으로 한다.
   *
   * content 타입은 AlertModalProps 를 따라 React.ReactNode 다. string 으로 좁히는 걸 검토했으나
   * useSettlementConfirm.tsx 가 실제로 JSX content(VStack/Text 조합)를 넘긴다 — 좁히면 그 호출부가
   * 컴파일이 깨진다. JSX 는 렌더마다 새 객체라 `===` 비교가 항상 거짓이므로 어차피 dedupe 가
   * 안 걸리지만, typeof 로 명시해 둔다 — 누군가 JSX 를 모듈 최상단 상수로 빼서 참조가 우연히
   * 같아지면 그때만 조용히 dedupe 가 걸리는 함정을 막는다. String(content) 비교로 바꾸는 안도
   * 검토했으나 JSX 는 전부 "[object Object]" 로 같아져 서로 다른 JSX 알럿끼리 오탐 dedupe 되므로
   * 기각한다.
   */
  show = (content: React.ReactNode, props?: Omit<MAlertActionType, 'id' | 'content'>) => {
    const id = Utils.uuid()

    // 같은 문구가 이미 떠 있으면 겹쳐 쌓지 않는다. 대신 기존 항목을 지우고 새 id 로 다시 넣어
    // key 를 바꾼다 — AlertModalList 가 이걸 새 마운트로 보고 모달을 다시 열어(포커스·애니메이션 재생,
    // status="error" 면 알림음 재생) 두 번째 호출도 사용자에게 보이게 한다.
    const duplicateIdx = typeof content === 'string' ? this.list.findIndex((alert) => alert.content === content) : -1
    if (duplicateIdx >= 0) {
      this.list.splice(duplicateIdx, 1)
    }
    this.list.push({ ...props, content, id })

    if (this.root) {
      this.root.render(<AlertModalList list={this.list} destroy={this.destroy} />)
    }
  }
}

const MAlert = new MAlertAction(ALERT_ID)
export default MAlert
